<template>
    <div class="page-container">
        <div class="content" v-html="protocol.content"></div>
    </div>
</template>

<script>
import { getprotocol } from "@/api/product";
import { Toast } from "vant";

export default {
    components: {
        [Toast.name]: Toast
    },
    name: "index",
    data: () => ({
        id: "",
        productId: "",
        amount: "",
        protocol: {}
    }),
    beforeMount() {
        this.id = this.$route.query.id;
        this.productId = this.$route.query.productId;
        this.tradeAmount = this.$route.query.tradeAmount;
        this.token = this.$route.query.token;

        this.$store.state.user.token = this.token;
        this.fetch();
    },
    methods: {
        fetch() {
            this._showLoading();
            getprotocol(this.productId, this.id, this.tradeAmount)
                .then(data => {
                    this.protocol = data;
                    if (!data) {
                        Toast("服务器繁忙, 请稍后再试");
                        return;
                    }
                    
                    document.title = data.title;
                    this._dismissLoading();
                })
                .catch(e => {
                    this._dismissLoading();
                    Toast(e.msg || e.message);
                });
        }
    },
    components: {
    }
};
</script>

<style lang="less" scoped>
.content {
    padding: 20px;
}
.van-nav-bar {
    background: #fff;

    .van-nav-bar__title {
        color: @dark;
    }
    .van-icon {
        color: @dark !important;
    }
}
</style>